import { httpV2 } from "@/api";

/**
 * Busca funcionalidades de acordo com a unidade geradora.
 * @param {number} monitoringElementId Identificador da unidade geradora.
 * @returns {Promise} Contendo uma lista de funcionalidades e seu estado.
 */
const GetGeneratingUnitFeatures = (monitoringElementId) =>
{
	return httpV2.get(`GeneratingUnitFeatures/${monitoringElementId}`);
};

export default { GetGeneratingUnitFeatures };